<template>
  <div class="Neewerai-version">
    <pageTitle v-bind="{ ...pT }" />
    <business-group
      ref="businessGroup"
      :tableConfig="{ ...tableConfig }"
      :formConfig="{ ...formConfig }"
    >
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-select placeholder="请选择模块类型" v-decorator="['moduleName']" style="width: 180px">
            <a-select-option v-for="el in moduleNameMap" :value="el.value" :key="el.value">{{
              el.label
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="请输入版本号"
            v-decorator="['versionNumber']"
            style="width: 200px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
      </template>
      <template slot="formRight">
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="moduleNameSlot" slot-scope="record">
        {{ moduleNameMap.find((e) => e.value === record.moduleName)?.label || record.moduleName }}
      </template>
      <template slot="versionDate" slot-scope="record">
        {{ dataFormatStr(record.versionDate, "YYYY-MM-DD") }}
      </template>
      <template slot="createTime" slot-scope="record">
        {{ dataFormatStr(record.createTime) }}
      </template>
      <template slot="updateTime" slot-scope="record">
        {{ dataFormatStr(record.updateTime) }}
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="del(record)">删除</a-button>
      </template>
    </business-group>
    <a-modal
      :visible="visible"
      :title="title"
      destroyOnClose
      @ok="submitForm('ruleForm')"
      @cancel="resetForm('ruleForm')"
      :maskClosable="false"
      width="800px"
    >
      <a-form-model
        ref="ruleForm"
        class="Neewerai-version_ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="模块类型" prop="moduleName">
          <a-select v-model="ruleForm.moduleName" placeholder="请选择模块类型">
            <a-select-option v-for="el in moduleNameMap" :key="el.value" :value="el.value">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="版本号" prop="versionNumber">
          <a-input
            type="text"
            placeholder="请输入版本号"
            v-model="ruleForm.versionNumber"
            :max-length="64"
          />
        </a-form-model-item>
        <a-form-model-item label="版本日期" prop="versionDate">
          <a-date-picker v-model="ruleForm.versionDate" :format="dateFormat" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="版本更新内容" prop="versionUpdateContent">
          <a-textarea
            placeholder="请输入版本更新内容"
            :rows="4"
            :maxLength="2048"
            v-model="ruleForm.versionUpdateContent"
          />
        </a-form-model-item>
        <a-form-model-item label="版本更新详细说明（富文本）" prop="versionUpdateDetailContent">
          <edit-components
            v-if="visible"
            :content="ruleForm.versionUpdateDetailContent"
            :html-change="onVersionUpdateDetailContentChange"
            :uploadImg="uploadRichTextImg"
            :upload-path="richTextUploadPath"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import editComponents from "@/components/EditComponents";
import { confirm, tips } from "@/utils/util";
import moment from "moment";
import { multipartUpload } from "@/utils/Oss";
import { formatToStr } from "@/utils/dateUtils";

export default {
  components: {
    pageTitle,
    businessGroup,
    editComponents
  },
  name: "Neewerai-version",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined || value === null) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };

    return {
      moduleNameMap: [
        { value: 1, label: "Neewer Home AI" },
        { value: 2, label: "Neewer Studio AI" }
      ],
      dateFormat: this.$root.$data.dateFormat,
      title: undefined,
      pT: {
        pageTitle: "AI 版本管理"
      },
      tableConfig: {
        url: "bluetoothlight/web/version/ai/getPage",
        columns: [
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            align: "center"
          },
          {
            title: "模块类型",
            key: "moduleName",
            align: "center",
            scopedSlots: { customRender: "moduleNameSlot" }
          },
          {
            title: "版本号",
            dataIndex: "versionNumber",
            key: "versionNumber",
            align: "center"
          },
          {
            title: "版本日期",
            key: "versionDate",
            align: "center",
            scopedSlots: { customRender: "versionDate" }
          },
          {
            title: "版本更新内容",
            dataIndex: "versionUpdateContent",
            key: "versionUpdateContent",
            align: "center"
          },
          {
            title: "创建时间",
            align: "center",
            scopedSlots: { customRender: "createTime" }
          },
          {
            title: "更新时间",
            align: "center",
            scopedSlots: { customRender: "updateTime" }
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "action" }
          }
        ],
        rowKey: "id"
      },
      formConfig: {
        timeShow: false,
        formShow: true
      },
      pageLoading: false,
      loading: false,
      visible: false,
      ruleForm: {},
      rules: {
        moduleName: [
          { required: true, validator: validatePass, trigger: "change", message: "模块类型不能为空" }
        ],
        versionNumber: [
          { required: true, validator: validatePass, trigger: "change", message: "版本号不能为空" }
        ],
        versionDate: [
          { required: true, validator: validatePass, trigger: "change", message: "版本日期不能为空" }
        ]
      },
      richTextUploadPath: "bluetooth_light/ai_version_richtext"
    };
  },
  methods: {
    moment,
    dataFormatStr(ret, format) {
      if (!ret) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret, format);
    },
    add() {
      this.title = "新增";
      this.ruleForm = { versionUpdateDetailContent: "" };
      this.visible = true;
    },
    details: async function(id) {
      if (this.loading) return false;
      this.loading = true;
      const res = await this.$get(`bluetoothlight/web/version/ai/detail/${id}`);
      this.loading = false;
      return res?.resultData || {};
    },
    edit: async function(record) {
      const data = await this.details(record?.id);
      data.versionDate = moment(data.versionDate);
      this.ruleForm = {
        ...data,
        versionUpdateDetailContent:
          data.versionUpdateDetailContent ?? data.version_update_detail_content ?? ""
      };
      this.title = "编辑";
      this.visible = true;
    },
    del(record) {
      const id = record?.id;
      if (!id || this.pageLoading) return false;

      this.pageLoading = true;

      const payload = {
        okBack: async () => {
          const res = await this.$http("DELETE", `bluetoothlight/web/version/ai/delete/${id}`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: "是否删除该 AI 版本"
      };
      confirm(this, payload);
      this.pageLoading = false;
    },
    submitForm(formName) {
      if (!formName) return false;
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return false;

        let versionDate = this.ruleForm?.versionDate;
        if (versionDate) {
          versionDate = this.dataFormatStr(versionDate, "YYYY-MM-DD");
        }

        const payload = {
          id: this.ruleForm?.id,
          moduleName: this.ruleForm?.moduleName,
          versionNumber: this.ruleForm?.versionNumber,
          versionDate,
          versionUpdateContent: this.ruleForm?.versionUpdateContent,
          versionUpdateDetailContent: this.ruleForm?.versionUpdateDetailContent
        };

        let res;
        if (this.title === "新增") {
          res = await this.$put("bluetoothlight/web/version/ai/add", payload);
        } else {
          res = await this.$post("bluetoothlight/web/version/ai/edit", payload);
        }

        const resultStatus = res?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.visible = false;
          this.refreshData();
          this.resetForm("ruleForm");
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName]?.resetFields?.();
      this.visible = false;
      this.ruleForm = {};
    },
    refreshData() {
      this.$refs?.businessGroup?.getData?.();
    },
    onVersionUpdateDetailContentChange(html) {
      this.ruleForm.versionUpdateDetailContent = html;
    },
    uploadRichTextImg: async function(file, callback, contextPath) {
      const res = await multipartUpload(file?.name, file, null, contextPath || "bluetooth_light");
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
        return false;
      }
      callback && callback?.(res?.url);
    }
  }
};
</script>

<style lang="less" scoped>
.Neewerai-version_ruleForm {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;

  .ant-form-item-children,
  .ant-calendar-picker {
    width: 100%;
  }
}
</style>
